import classNames from "classnames";
import React, { FC } from "react";

type FourthStepInfoContainerProps = {
  higherZIndex?: boolean;
  transparent?: boolean;
  noPadding?: boolean;
  backgroundColor?: string;
};

export const FourthStepInfoContainer: FC<FourthStepInfoContainerProps> = ({
  children,
  higherZIndex = false,
  transparent = false,
  noPadding = false,
  backgroundColor,
}) => {
  return (
    <div className="row mb-3">
      <div className="edge-to-edge-sm">
        <div
          className={classNames("card", {
            "card-wings-sm": !backgroundColor,
            "card-wings-sm__custom-background-color": backgroundColor,
            "card__with-high-z-index": higherZIndex,
            "card-wings-sm-no-bg": transparent,
          })}
          style={{ backgroundColor: backgroundColor }}
        >
          <div
            className={classNames("fs-5", {
              "card-body px-2 px-sm-0 py-sm-3 py-sm-3": !noPadding,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
